import Flickity from 'flickity'

export default class OurProductsCarousel {
  constructor (el) {
    /* eslint-disable */
    const flkty = new Flickity(el, {
      cellAlign: 'center',
      contain: true,
      imagesLoaded: true,
      wrapAround: true,
      prevNextButtons: false,
      watchCSS: true
    })
    /* eslint-enable */
  }
}
